import { styled } from '@mui/material/styles';

export const StyledButtonWrapper = styled('div')(
  ({ theme }) => `
    flex: 1;
    display: flex;
    margin-top: ${theme.DS_spacing(['xs'])};
  
    a, button {
      align-self: flex-end;
      padding: 0;
    }
    
     &.impress > a  {
       height: 48px;
       min-height: unset;

    
      }
  
    &.fix-width {
      margin-top: 0.75rem;
      
      a, button {
        min-width: 247px;
      }
    }
    
    &.impress a {
        min-width: 216px;
        width: 100%;
    }
 
    ${theme.breakpoints.up('lg')} {
      &.fix-width a, button {
        min-width: 254px;
      }
      
     &.impress > a {
       height: 52px;
       min-height: unset;
       weight: 100%;
      
          span{
          span {
              line-height: 22px;
          }
          }
      }
  
    }
  `,
);
